import { useTheme } from "@hooks";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      textAlign: "center",
      padding: 32,
    },
    primary: {
      fontWeight: 700,
      fontSize: 24,
      marginBottom: 12,
    },
    secondary: {
      color: theme.text.secondary,
    },
  };

  return styles;
};
